import React, { useEffect, useState } from 'react';

const Projects: React.FC = () => {
  const [LRPPlayers, setLRPPlayers] = useState(0);
  const [FinalCityPlayers, setFinalCityPlayers] = useState(0);
  const [frameworkServers, setFrameworkServers] = useState(0);
  const [frameworkServers2, setFrameworkServers2] = useState(0);
  const [visibleCards, setVisibleCards] = useState<Set<number>>(new Set());

  useEffect(() => {
    const cards = document.querySelectorAll('.project-card');
    cards.forEach((card, index) => {
      setTimeout(() => {
        setVisibleCards(prev => new Set(Array.from(prev).concat(index)));
      }, index * 100);
    });
  }, []);

  useEffect(() => {
    const animateCounter = (setter: (value: number) => void, target: number, duration: number) => {
      let current = 0;
      const increment = target / (duration / 16);
      const startTime = Date.now();

      const timer = setInterval(() => {
        const elapsed = Date.now() - startTime;
        current += increment;

        if (current >= target || elapsed >= duration) {
          setter(target);
          clearInterval(timer);
        } else {
          setter(Math.floor(current));
        }
      }, 16);
    };

    setTimeout(() => {
      animateCounter(setLRPPlayers, 120, 1800);
      animateCounter(setFinalCityPlayers, 430, 800);
      animateCounter(setFrameworkServers, 120, 2100);
      animateCounter(setFrameworkServers2, 600, 2100);
    }, 3800);
  }, []);

  const projects = [
    {
      logo: "https://brxttypotter.isfucking.pro/v6l8W1.gif",
      title: "LightningRP",
      period: "Oct 2024 - Jan 2026",
      stats: [
        { value: LRPPlayers, label: "Players" },
        { value: "24/7", label: "Uptime" }
      ],
      description: "Developed core gameplay systems and optimized server performance. Introduced new gangwar system, new events and improved admin systems."
    },
    {
      logo: "https://brxttypotter.isfucking.pro/noUMVf.gif",
      title: "rakiselling.xyz",
      period: "July 2022 - Sep 2025",
      stats: [
        { value: frameworkServers, label: "Usage per day" },
        { value: "99%", label: "Stability" }
      ],
      description: "Supporter and lead engineer. Developed APIs, Cheats, new features, the websites and discord bots."
    },
    {
      logo: "https://brxttypotter.isfucking.pro/42avlL.png",
      title: "DCCars",
      period: "Oct 2025 - Present",
      stats: [
        { value: frameworkServers2, label: "Usage per day" },
        { value: "24/7", label: "Uptime" }
      ],
      description: "Helping customers, head developer, increase support performance."
    },
    {
      logo: "https://brxttypotter.isfucking.pro/KovEG1.gif",
      title: "Final City",
      period: "Feb 2026 - Present",
      stats: [
        { value: FinalCityPlayers, label: "Players" },
        { value: "24/7", label: "Uptime" }
      ],
      description: "Responsible for the cars and car economy."
    },
    {
      logo: "https://brxttypotter.isfucking.pro/eXigSk.gif",
      title: "ClassicV",
      period: "May 2026 - Present",
      stats: [
        { value: "40", label: "Players" },
        { value: "24/7", label: "Uptime" }
      ],
      description: "Creating new scripts, increase performances and fixes bugs."
    }
  ];

  return (
    <section className="section" id="projects">
      <div className="section-container">
        <h2 className="section-title">Featured Projects</h2>
        <div className="skills-grid">
          {projects.map((project, index) => (
            <div
              key={index}
              className="project-card"
              style={{
                opacity: visibleCards.has(index) ? 1 : 0,
                transform: visibleCards.has(index) ? 'translateY(0)' : 'translateY(30px)',
                transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)'
              }}
            >
              <div className="project-header">
                <img className="server-logo" src={project.logo}></img>
                <div className="project-info">
                  <h3 className="project-title">{project.title}</h3>
                  <div className="project-period">{project.period}</div>
                </div>
              </div>
              <div>
                <div className="project-stats">
                  {project.stats.map((stat, statIndex) => (
                    <div key={statIndex} className="stat">
                      <div className="stat-value">{stat.value}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  ))}
                </div>
                <p className="project-description">{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;